interface CountCardProps {
	number: number;
	title: string;
}

const CountCard = ({ number, title }: CountCardProps) => {
	return (
		<div
			className='group relative overflow-hidden rounded-xl bg-white px-6 py-5 shadow-sm ring-1 ring-gray-900/5 transition-all duration-300 hover:shadow-md hover:ring-brand-500/20 sm:px-8 sm:py-6'
			style={{ maxWidth: '180px' }}>
			{/* Background gradient effect */}
			<div className='absolute inset-0 bg-gradient-to-br from-brand-50/50 to-transparent opacity-0 transition-opacity duration-300 group-hover:opacity-100' />

			{/* Content */}
			<div className='relative'>
				<dt className='truncate text-sm font-medium text-gray-600'>{title}</dt>
				<dd className='mt-2 flex items-baseline justify-center'>
					<div className='text-3xl font-semibold tracking-tight text-brand-600'>
						{number.toLocaleString()}
					</div>
				</dd>
			</div>
		</div>
	);
};

export default CountCard;
